export default __webpack_public_path__ + "static/media/warmilab.5d17d7aa.png";